module.exports = __webpack_public_path__ + "static/media/arrow-left-blue.21769f20.svg";